<div class="modal__wrapper">
  <div class="modal__content">
    <h4>Product unavailable</h4>

    <ng-container *ngIf="numberOfReplacementOffers > 1; else BespokeErrorModal">
      <p class="description">
        Unfortunately this product is currently unavailable. Don't worry, we
        have other options to choose from.
      </p>

      <dgx-components-button [fill]="true" (clicked)="onBackLinkClick()">
        See other options
      </dgx-components-button>
    </ng-container>

    <ng-template #BespokeErrorModal>
      <p class="description">
        Sorry, this product is no longer available. To place your order, please
        call us or start an online chat.
      </p>

      <p class="live-chat">
        Live chat is available Monday to Friday 8am-6pm, and Saturday
        8.30am-4.30pm.
      </p>

      <dgx-components-button
        [fill]="true"
        [disabled]="!isLiveChatActive"
        (clicked)="openLiveChat()"
      >
        Start chat
      </dgx-components-button>

      <p class="call-us">Or call us on:</p>

      <section class="call-link">
        <dgx-components-icon name="phone"> </dgx-components-icon>
        <a href="tel:03330004970"> 0333 000 4970 </a>
      </section>

      <p class="call-cost">
        Calls cost the basic rate per minute plus your phone company’s access
        charge. From a mobile, they can cost much more.
      </p>
    </ng-template>
  </div>
</div>
